export type ConnectionState = "online" | "slow" | "reconnecting" | "offline";

export interface ResilienceSnapshot {
  readonly state: ConnectionState;
  readonly code: string | null;
  readonly since: number;
}

type ResilienceListener = () => void;

const listeners = new Set<ResilienceListener>();

let snapshot: ResilienceSnapshot = {
  state: "online",
  code: null,
  since: Date.now(),
};

export function getResilienceSnapshot(): ResilienceSnapshot {
  return snapshot;
}

export function subscribeResilience(listener: ResilienceListener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function reportResilienceState(
  state: ConnectionState,
  code: string | null = null,
): void {
  if (snapshot.state === state && snapshot.code === code) return;
  snapshot = { state, code, since: Date.now() };
  logResilienceState(snapshot);
  for (const listener of listeners) listener();
}

function logResilienceState(next: ResilienceSnapshot): void {
  console.warn(
    JSON.stringify({
      event: "resilience_state",
      category: next.state,
      code: next.code,
      since: next.since,
    }),
  );
}
